import { z } from "zod";

const webflowFieldTypeSchema = z.enum([
  "PlainText",
  "RichText",
  "MultiReference",
  "Reference",
  "File",
  "Option",
  "Color",
  "Switch",
  "DateTime",
  "Number",
  "Phone",
  "Email",
  "Link",
  "VideoLink",
  "Image",
  "MultiImage",
]);

export default webflowFieldTypeSchema;
